import { useCallback, useEffect, useRef } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { WorkspaceCreateValues } from './workspaceCreateModel';

/**
 * Die Kontakt-E-Mail folgt sichtbar der Adresse des ersten Administrators, bis jemand sie selbst
 * bearbeitet. Vorher setzte der Server sie unsichtbar — und machte so die private Adresse einer
 * Person zur Antwortadresse aller Gästemails, ohne dass es im Formular stand.
 */
export function useContactPrefill(
  form: Pick<UseFormReturn<WorkspaceCreateValues>, 'watch' | 'setValue'>,
  open: boolean,
) {
  const edited = useRef(false);
  const adminEmail = form.watch('adminEmail');
  const inviteAdmin = form.watch('inviteAdmin');
  const { setValue } = form;

  useEffect(() => {
    if (open) edited.current = false;
  }, [open]);

  useEffect(() => {
    if (!edited.current) setValue('contactEmail', inviteAdmin ? adminEmail.trim() : '');
  }, [adminEmail, inviteAdmin, setValue]);

  const markEdited = useCallback(() => {
    edited.current = true;
  }, []);

  return { markEdited };
}
